const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'projectTermJobs',
        grantedMinorChangesForFieldCodes: {
            // timeRange: true,
        },
    },

    model: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
    },

    methods: {
        // /**
        //  * this function will be called after the form values has been changed.
        //  *
        //  * @param isRelationChange 		boolean - was the change related to a relation or not
        //  * @param changeDone 			boolean - has a change been done
        //  * @param fieldData 			{} - fieldData used to define what to do
        //  */
        // onChange: function(isRelationChange, changeDone, fieldData){
        //     fieldData = fieldData || {}
        //     let $resetAutoComplete
        //     if(fieldData.fieldCode === 'contractorID' && fieldData.fieldValue){
        //         $resetAutoComplete = this.$.find('[data-field-code="employeeID"]')
        //     } else if(fieldData.fieldCode === 'employeeID' && fieldData.fieldValue){
        //         $resetAutoComplete = this.$.find('[data-field-code="contractorID"]')
        //     }
        //
        //     if(($resetAutoComplete || {}).length > 0){
        //         const resetAutoComplete = getComponent($resetAutoComplete)
        //         if(resetAutoComplete){
        //             resetAutoComplete.unChoose()
        //         }
        //     }
        // },

        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                !this.config.creationMode
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                this.refresh(false)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(!this.config.creationMode) {
                if(utils.isEmpty(this.model.projectMeta)){
                    this.locate('< base_tabStrip_tabStrip > templates_customers_projectTerms_controller', controller => {
                        this.model.projectMeta = {
                            ...(controller.model.projectMeta || {})
                        }
                    })
                }

                // disable fields on non drafters
                const projectTermID = ((this.resourceData.data || {}).attributes || {}).projectTermID
                let grantedChanges = ((this.model.projectMeta || {}).grantedChanges || {}).project || {}
                if(projectTermID){
                    grantedChanges = (((this.model.projectMeta || {}).grantedChanges || {}).projectTerms || {})[projectTermID] || {}
                }

                for(const fieldCode in this.model.namedFields){
                    const field = this.model.namedFields[fieldCode] || {}
                    field.config = field.config || {}

                    if(field.config.disabledBackup === undefined && field.config.disabled !== undefined){
                        field.config.disabledBackup = !!field.config.disabled
                    }

                    if(grantedChanges.major || grantedChanges.minor && this.config.grantedMinorChangesForFieldCodes[fieldCode]){
                        field.config.disabled = !!field.config.disabledBackup
                    } else {
                        field.config.disabled = true
                    }
                }
            }
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}